<template>
  <div>
    <b-overlay spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
      <b-card title="">
        <b-row xl="12" sm="12">
          <b-col cols="6">
            <table class="w-100">
              <tr>
                <th>
                  <span class="font-weight-bold">DEVICE {{ this.form.device_code }}</span>
                </th>
              </tr>
            </table>
          </b-col>
        </b-row>
      </b-card>
      <div class="">
        <div class="row">
          <div class="col-md-12">
            <b-card>
              <b-row class="my-2 ml-1">
                <b-col cols="4">
                  <span class="font-weight-bold transparent-text">.</span>
                  <table class="mt-2 mt-xl-0 w-100">
                    <!-- Before table content here -->
                    <tr>
                      <th class="pb-50">
                        <span class="font-weight-bold">PROVINCE :</span>
                      </th>
                    </tr>
                    <tr>
                      <th class="pb-50">
                        <span class="font-weight-bold">REGENCY :</span>
                      </th>
                    </tr>
                    <tr>
                      <th class="pb-50">
                        <span class="font-weight-bold">SITE :</span>
                      </th>
                    </tr>
                    <tr>
                      <th class="pb-50">
                        <span class="font-weight-bold">AREA :</span>
                      </th>
                    </tr>
                    <tr>
                      <th class="pb-50">
                        <span class="font-weight-bold">LOCATION :</span>
                      </th>
                    </tr>
                    <tr>
                      <th class="pb-50">
                        <span class="font-weight-bold">TYPE :</span>
                      </th>
                    </tr>
                    <tr>
                      <th class="pb-50">
                        <span class="font-weight-bold">SERIAL NUMBER :</span>
                      </th>
                    </tr>
                    <tr>
                      <th class="pb-50">
                        <span class="font-weight-bold">CODE :</span>
                      </th>
                    </tr>
                    <tr>
                      <th class="pb-50">
                        <span class="font-weight-bold">MSISDN :</span>
                      </th>
                    </tr>
                    <tr>
                      <th class="pb-50">
                        <span class="font-weight-bold">NOTE :</span>
                      </th>
                    </tr>
                    <tr>
                      <th class="pb-50">
                        <span class="font-weight-bold">LAST ONLINE :</span>
                      </th>
                    </tr>

                    <tr>
                      <th class="pb-50">
                        <span class="font-weight-bold">LAST GET DATA :</span>
                      </th>
                    </tr>
                    <tr>
                      <th class="pb-50">
                        <span class="font-weight-bold">LAST SENT DATA :</span>
                      </th>
                    </tr>

                  </table>
                </b-col>
                <b-col cols="4">
                  <span class="font-weight-bold">BEFORE</span>
                  <table class="mt-2 mt-xl-0 w-100">
                    <!-- After table content here -->
                    <tr>
                      <td class="pb-50">
                        {{ this.form.province_name }}
                      </td>
                    </tr>
                    <tr>
                      <td class="pb-50">
                        {{ this.form.regency_name }}
                      </td>
                    </tr>
                    <tr>
                      <td class="pb-50">
                        {{ this.form.site_name }}
                      </td>
                    </tr>
                    <tr>
                      <td class="pb-50">
                        {{ this.form.area_name }}
                      </td>
                    </tr>
                    <tr>
                      <td class="pb-50">
                        {{ this.form.location_name }}
                      </td>
                    </tr>
                    <tr>
                      <td class="pb-50">
                        {{ this.form.device_type_name }}
                      </td>
                    </tr>
                    <tr>
                      <td class="pb-50">
                        {{ this.form.device_serial_number }}
                      </td>
                    </tr>
                    <tr>
                      <td class="pb-50">
                        {{ this.form.device_code }}
                      </td>
                    </tr>
                    <tr>
                      <td class="pb-50">
                        {{ this.form.device_msisdn }}
                      </td>
                    </tr>
                    <tr>
                      <td class="pb-50">
                        {{ this.form.device_note }}
                      </td>
                    </tr>
                    <tr>
                      <td class="pb-50">
                        {{ this.form.last_online_device }}
                      </td>
                    </tr>

                    <tr>
                      <td class="pb-50">
                        {{ this.form.device_last_get_data }}
                      </td>
                    </tr>
                    <tr>
                      <td class="pb-50">
                        {{ this.form.device_last_send_data }}
                      </td>
                    </tr>

                  </table>
                </b-col>
                <b-col cols="4">
                  <span class="font-weight-bold">AFTER</span>
                  <table class="mt-2 mt-xl-0 w-100">
                    <!-- After table content here -->
                    <tr>
                      <td class="pb-50">
                        {{ this.form.province_name }}
                      </td>
                    </tr>
                    <tr>
                      <td class="pb-50">
                        {{ this.form.regency_name }}
                      </td>
                    </tr>
                    <tr>
                      <td class="pb-50">
                        {{ this.form.site_name }}
                      </td>
                    </tr>
                    <tr>
                      <td class="pb-50">
                        {{ this.form.area_name }}
                      </td>
                    </tr>
                    <tr>
                      <td class="pb-50">
                        {{ this.form.location_name }}
                      </td>
                    </tr>
                    <tr>
                      <td class="pb-50">
                        {{ this.form.device_type_name }}
                      </td>
                    </tr>
                    <tr>
                      <td class="pb-50">
                        {{ this.form.device_serial_number }}
                      </td>
                    </tr>
                    <tr>
                      <td class="pb-50">
                        {{ this.form.device_code }}
                      </td>
                    </tr>
                    <tr>
                      <td class="pb-50">
                        {{ this.form.device_msisdn }}
                      </td>
                    </tr>
                    <tr>
                      <td class="pb-50">
                        {{ this.form.device_note }}
                      </td>
                    </tr>
                    <tr>
                      <td class="pb-50">
                        {{ this.form.last_online_device }}
                      </td>
                    </tr>

                    <tr>
                      <td class="pb-50">
                        {{ this.form.device_last_get_data }}
                      </td>
                    </tr>
                    <tr>
                      <td class="pb-50">
                        {{ this.form.device_last_send_data }}
                      </td>
                    </tr>

                  </table>
                </b-col>
              </b-row>
            </b-card>
          </div>
        </div>
      </div>

      <b-row>
        <b-col lg="3" md="6">
          <b-card>
            <b-card-header>
              <b-card-title>Progress</b-card-title>
            </b-card-header>
            <b-card-body style="padding-bottom: 10rem;">

              <div>
                <b-media no-body>
                  <b-media-aside>
                    <b-avatar rounded size="42" variant="primary">
                      <feather-icon size="18" icon="BellIcon" />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body>
                    <h6>
                      Error
                    </h6>
                    <small>Barang rusak</small>
                  </b-media-body>
                </b-media>
              </div>

              <div style="margin-top: 2rem;">
                <b-media no-body>
                  <b-media-aside>
                    <b-avatar rounded size="42" variant="secondary">
                      <feather-icon size="18" icon="BoxIcon" />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body>
                    <h6>
                      L2
                    </h6>
                    <small>Troubleshooting</small>
                  </b-media-body>
                </b-media>
              </div>

              <div style="margin-top: 2rem;">
                <b-media no-body>
                  <b-media-aside>
                    <b-avatar rounded size="42" variant="secondary">
                      <feather-icon size="18" icon="TruckIcon" />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body>
                    <h6>
                      Shipment
                    </h6>
                    <small>Sedang Pengiriman</small>
                  </b-media-body>
                </b-media>
              </div>

              <div style="margin-top: 2rem;">
                <b-media no-body>
                  <b-media-aside>
                    <b-avatar rounded size="42" variant="secondary">
                      <feather-icon size="18" icon="exclamation-circle-fill" />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body>
                    <h6>
                      Visit
                    </h6>
                    <small>Teknisi Menuju Lokasi</small>
                  </b-media-body>
                </b-media>
              </div>

              <div style="margin-top: 2rem;">
                <b-media no-body>
                  <b-media-aside>
                    <b-avatar rounded size="42" variant="secondary">
                      <feather-icon size="18" icon="ToolIcon" />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body>
                    <h6>
                      Instalsai
                    </h6>
                    <small>Proses Installasi</small>
                  </b-media-body>
                </b-media>
              </div>

              <div style="margin-top: 2rem;">
                <b-media no-body>
                  <b-media-aside>
                    <b-avatar rounded size="42" variant="secondary">
                      <feather-icon size="18" icon="CheckIcon" />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body>
                    <h6>
                      Online
                    </h6>
                    <small>Device Status Online</small>
                  </b-media-body>
                </b-media>
              </div>

            </b-card-body>
          </b-card>
        </b-col>
        <b-col lg="9" md="6">
          <b-card>
            <b-card-header>
              <b-card-title>Remark</b-card-title>
            </b-card-header>
            <b-table striped hover responsive class="position-relative" :items="items" :fields="fields">
            </b-table>
            <b-card-body style="padding-bottom: 18.6rem;">
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-overlay>
  </div>
</template>

<script>
import { BIconCircleFill, BIcon, BDropdownItem, BDropdown, BCardBody, BRow, BInputGroup, BInputGroupAppend, BCol, BFormGroup, BFormCheckbox, BFormInput, BFormFile, BForm, BButton, BCardText, BMediaAside, BMediaBody, BLink, BCardHeader, BCardTitle, BPopover, BOverlay, BCard, BTable, BImg, BMedia, BAvatar, BBadge, BPagination, BFormSelect } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { mapState } from 'vuex'
import moment from 'moment'
import store from '@/store/index'
import VueApexCharts from 'vue-apexcharts'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'

export default {
  components: { vSelect, flatPickr, BIconCircleFill, BIcon, BDropdownItem, BDropdown, BCardBody, BInputGroup, BInputGroupAppend, BOverlay, ValidationProvider, ValidationObserver, BCard, BCardText, BRow, BCol, BFormGroup, BFormCheckbox, BFormInput, BFormFile, BForm, BButton, BMedia, BMediaAside, BLink, BImg, BCardHeader, BCardTitle, BPopover, BOverlay, vSelect, flatPickr, moment, VueApexCharts, BCard, BCardText, BMedia, BAvatar, BMediaAside, BMediaBody, BTable, BImg, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BLink, BRow, BCol, BDropdown, BDropdownItem, ToastificationContent },
  directives: { Ripple },
  data() {
    return {
      fields: [
        { key: 'time', label: 'Time' },
        { key: 'changes', label: 'Changes' },
        { key: 'remark', label: 'Remark' },
      ],
      items: [
        { id: 1, time: 'Now', changes: 'Error', remark: 'Remark 1' },
        { id: 2, time: '2024-02-20 10:30', changes: 'Open L2', remark: 'Remark 2' },
        { id: 3, time: '2024-02-20 13:45', changes: 'Shipment', remark: 'Remark 3' },
        { id: 4, time: '2024-02-20 14:45', changes: 'Visit', remark: 'Remark 4' },
        { id: 5, time: '2024-02-20 15:45', changes: 'Instalasi', remark: 'Remark 5' }
      ],
      form: {
        site_name: "",
        area_name: "",
        location_name: "",
        device_type_name: "",
        device_name: "",
        device_code: "",
        device_msisdn: 0,
        device_iccid: 0,
        device_note: "",
        device_value: 0,
        device_value_power: 0,
        device_signal_strength: 0,
        last_online_device: "",
        device_serial_number: 0,
        device_last_get_data: "",
        device_last_send_data: "",
        device_is_offline_alarm: false,
        device_is_over_limit_max: false,
        device_is_over_limit_min: false,
        device_is_probe_fault: false,
        device_is_power_low: false,
        device_is_power_shutdown: false,
        device_is_power_disconnect: false,
        device_latitude: "",
        device_longitude: "",
        device_status: "",
        province_name: "",
        regency_name: "",
      },
      show: false,
      contentData: null,
      geocoder: "",
      required
    }
  },
  computed: {
    ...mapState({
      SiteOptions: state => state.site.options,
      ProvinceOptions: state => state.region.province,
      RegencyOptions: state => state.region.regency,
      DistrictOptions: state => state.region.district,
      DeviceOptions: state => state.device.options
    }),
    direction() {
      if (store.state.appConfig.isRTL) {
        this.dir = true
        return this.dir
      }
      this.dir = false
      return this.dir
    }
  },
  watch: {
    select_6(obj) {
      return this.$store.dispatch('region/regency', obj)
    },
    select_7(obj) {
      return this.$store.dispatch('region/district', obj)
    },
    select_8(obj) {
      return this.$store.dispatch('site/getByFilter', obj)
    }
  },
  created() {
    this.$store.dispatch('site/getByNonFilter')
    this.$store.dispatch('region/province')
    this.$store.dispatch('device/getDeviceList')
  },
  methods: {
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    validationForm() {
      this.show = true
      this.$refs.simpleRules.validate()
        .then(success => {
          if (success) {
            const formData = this.form
            this.$store.dispatch('temperature/formPostPut', formData)
              .then(res => {
                this.notification('Success', 'CheckIcon', 'success', 'You have successfully')
              },
                err => {
                  this.show = false
                  this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
                })
          } else {
            this.show = false
            this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
          }
        })
    },
    notification(a, b, c, d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title: a, icon: b, variant: c, text: d }
      })
    },
    getData(id) {
      this.$store.dispatch('temperature/getByIdInstall', id).then(data => {
        if (data.device_status === "IN") {
          this.form.device_status = "ONLINE"
        }
        if (data.device_status === "ER") {
          this.form.device_status = "OFFLINE"
        }
        if (data.device_status === "FL") {
          this.form.device_status = "ERROR"
        }
        console.log(data)
        this.form.site_name = data.site_name
        this.form.area_name = data.area_name
        this.form.location_name = data.location_name
        this.form.device_type_name = data.device_type_name
        this.form.device_code = data.device_code
        this.form.device_serial_number = data.device_serial_number
        this.form.device_msisdn = data.device_msisdn
        this.form.device_iccid = data.device_iccid
        this.form.device_note = data.device_note
        this.form.device_value_name = data.device_value_name
        this.form.device_value = data.device_value
        this.form.device_value_power = data.device_value_power
        this.form.device_signal_strength = data.device_signal_strength
        this.form.last_online_device = moment(data.last_online_device).format('YYYY-MMM-DD, HH:mm:ss')
        this.form.device_last_get_data = moment(data.device_last_get_data).format('YYYY-MMM-DD, HH:mm:ss')
        this.form.device_last_send_data = moment(data.device_last_send_data).format('YYYY-MMM-DD, HH:mm:ss')
        this.form.device_is_offline_alarm = data.device_is_offline_alarm
        this.form.device_is_over_limit_max = data.device_is_over_limit_max
        this.form.device_is_over_limit_min = data.device_is_over_limit_min
        this.form.device_is_probe_fault = data.device_is_probe_fault
        this.form.device_is_power_low = data.device_is_power_low
        this.form.device_is_power_shutdown = data.device_is_power_shutdown
        this.form.device_is_power_disconnect = data.device_is_power_disconnect
        this.form.device_latitude = data.device_latitude
        this.form.device_longitude = data.device_longitude
        this.form.province_name = data.province_name
        this.form.regency_name = data.regency_name
        this.show = false
      })
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.show = true
      this.getData(this.$route.params.id)
    }
  }
}
</script>
<style scoped>
.card-text {
  font-weight: bold;
}
.transparent-text {
  opacity: 0; 
}
.font-weight-bold {
  font-weight: bold !important;
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>